import { DefaultTheme } from 'styled-components/macro';

export interface IColors {
  primaryColor: string;
  primaryColor80: string;
  primaryColor10: string;
  primaryColor5: string;
  secondaryColor: string;
  secondaryColor5: string;
  primaryButtonTextColor: string;
  secondaryButtonBgColor: string;
  navItemColor: string;
  sideBarColor: string;
}

export interface ILogos {
  small: string | undefined;
  normal: string | undefined;
}

export interface IFontSizes {
  /**
   * @desc xxs:12px
   */
  xxs: string;
  xs: string;
  sm: string;
  m: string;
  md: string;
  lg: string;
  xl: string;
  xxl: string;
}

export enum THEME_LABELS {
  AUTOMOTIVE = 'covideoAutomotiveTheme',
  COVIDEO = 'covideoTheme',
  VID = 'App2Vid',
  PRO_VIDEO = 'ProVideoNOW',
  KENNECTED = 'Kennected Video',
  VIDIS = 'Vidis',
}

export type ThemeTypes = {
  [THEME_LABELS.AUTOMOTIVE]: Omit<DefaultTheme, 'setTheme'>;
  [THEME_LABELS.COVIDEO]: Omit<DefaultTheme, 'setTheme'>;
  [THEME_LABELS.VID]: Omit<DefaultTheme, 'setTheme'>;
  [THEME_LABELS.PRO_VIDEO]: Omit<DefaultTheme, 'setTheme'>;
  [THEME_LABELS.KENNECTED]: Omit<DefaultTheme, 'setTheme'>;
  [THEME_LABELS.VIDIS]: Omit<DefaultTheme, 'setTheme'>;
};
